import type { ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
}

const BASE =
  'inline-flex items-center justify-center font-medium rounded-md transition-colors px-3 py-1.5 text-sm disabled:opacity-50 disabled:cursor-not-allowed';

const VARIANT: Record<ButtonVariant, string> = {
  primary: 'bg-accent text-[#001821] hover:brightness-110',
  secondary: 'bg-card border border-border text-text hover:border-accent',
  ghost: 'bg-transparent text-text-dim hover:text-text hover:bg-card/50',
};

export function Button({
  variant = 'secondary',
  className = '',
  ...rest
}: ButtonProps): JSX.Element {
  return <button className={`${BASE} ${VARIANT[variant]} ${className}`} {...rest} />;
}
